import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { SignOut, User } from "@phosphor-icons/react";
import QuietBayMark from "@/components/QuietBayMark";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const navItem = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${isActive ? "text-[#003D4C]" : "text-[#003D4C]/60 hover:text-[#003D4C]"}`;

  return (
    <header className="border-b hairline-soft sticky top-0 z-30 backdrop-blur-md bg-[#F5F1EA]/85" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <QuietBayMark size={38} color="#9D968D" />
          <div className="flex flex-col leading-none">
            <span className="font-display font-display-bold text-2xl tracking-tight text-[#003D4C]">Quiet Bay</span>
            <span className="font-display text-[11px] text-[#003D4C]/65 mt-1.5 hidden sm:inline tracking-wide">Far Beyond Hot <span className="amp">&amp;</span> Cold</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={navItem} data-testid="nav-home">Início</NavLink>
          <NavLink to="/book" className={navItem} data-testid="nav-book">Reservar</NavLink>
          {user && (
            <NavLink to="/my-bookings" className={navItem} data-testid="nav-my-bookings">As minhas reservas</NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink to="/admin" className={navItem} data-testid="nav-admin">Admin</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:flex items-center gap-2 text-sm text-[#003D4C]/65" data-testid="header-user-email">
                <User size={16} weight="light" />
                {user.email}
              </span>
              <button
                onClick={async () => { await logout(); navigate("/"); }}
                className="btn-ghost px-4 py-2 text-sm flex items-center gap-2"
                data-testid="logout-btn"
              >
                <SignOut size={16} weight="light" /> Sair
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-[#003D4C]/70 hover:text-[#003D4C] px-3 py-2" data-testid="nav-login">
                Entrar
              </Link>
              <Link to="/register" className="btn-hot px-5 py-2.5 text-sm" data-testid="nav-register">
                Criar conta
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
